import { apiService } from './index';
import { IRegisterAgent } from '../shared/types/general';

export const asyncGetUserLog = async () => {
    return await apiService.get('/api/users/profile');
};

export const asyncGetStatus = async () => {
    return await apiService.get('/api/status');
};

export const asyncPostAgent = async (formAgent: IRegisterAgent) => {
    return await apiService.post('/api/agents', formAgent);
};

export const asyncDepartments = async () => {
    return await apiService.get(`/api/location/department`);
};

export const asyncCities = async (idDepartment: string) => {
    return await apiService.get(`/api/location/cities/${idDepartment}`);
};

export const asyncCitiesByText = async (text: string) => {
    return await apiService.get(`/api/location/cities/search/${text}`);
};
